import { useEffect, useState } from "react";
import { get } from "../../utility/fetch";
import TagInputs from "./TagInputs";
import Select from 'react-select';

const AboutLab = ({ labName = "LAB", handleSubmit, aboutLabPayload, setAboutLabPayload }) => {

    const [careProviders, setCareProviders] = useState([]);



    const getCareProvider = async () => {
        let res = await get(`/healthcareprovider/getpaymentsources/1/10`)
        console.log(res)
        setCareProviders(res?.map(provider => ({
            label: provider?.paymentChannel,
            value: provider?.id
        })))
    }

    const handleSelectChange = (e) => {
        

        setAboutLabPayload({
            ...aboutLabPayload, healthCareProviderPaymentOptions: [
                ...e.map((item)=> ({
                     healthCareProviderId: localStorage.getItem('labId'),
                    paymentOptionsId: item.value,
                }))
            ]
        })
    }

    useEffect(() => {
        getCareProvider()
    }, [])


    const handleInputChange = (e) => {
        setAboutLabPayload({ ...aboutLabPayload, [e.target.name]: e.target.value })
    }

    return (
        <div className="w-30 m-b-40">
            <TagInputs value={aboutLabPayload?.labDetails} onChange={handleInputChange} name="labDetails" type='textArea' label={`About ${labName}`} />
            {/* <TagInputs value = {aboutLabPayload?.} onChange={handleInputChange} name = "labDetails" type='text' label="Services Offered" /> */}
            <TagInputs value={aboutLabPayload?.workDays} onChange={handleInputChange} name="workDays" type='text' label="Work Days" />
            <TagInputs value={aboutLabPayload?.workHours} onChange={handleInputChange} name="workHours" type='text' label="Work Hours" />
            <div className="m-t-10 m-b-10">
                <label htmlFor="healthCareProviderPaymentOptions">Payment Options</label>
                <Select isMulti={true} className="m-t-10 m-b-10" options={careProviders} onChange={handleSelectChange} id="healthCareProviderPaymentOptions" />
            </div>

            <TagInputs value={aboutLabPayload?.thingToKnow}  onChange={handleInputChange} name="thingToKnow" type='textArea' label="Top 3 things your client should know" />

            {/* <TagInputs value={aboutLabPayload?.healthCareProviderPaymentOptions} onChange={handleInputChange} name="" type='text' label="Payment Options" /> */}
        </div>)
}

export default AboutLab